import { DatePicker, Select } from "common/InputForm";
import { CustomButton, SearchBar } from "components/form";
import React, { useEffect, useState } from "react";
import { Pagination } from "react-bootstrap";
import { CgBlock, CgUnblock } from "react-icons/cg";
import { FaEye, FaRegStar, FaStar } from "react-icons/fa";
import { SlRefresh } from "react-icons/sl";
import { Link } from "react-router-dom";
import { RiDeleteBin5Line } from "react-icons/ri";
import { Rating } from "react-simple-star-rating";
import "./Feedback_manag.css";
import { CustomModal } from "components/modals/ModalBox";
import { RiDeleteBin6Line } from "react-icons/ri";
import { ronald_name } from "assets/icons";
import { toast } from "sonner";
import { getFeedbackAPI, getFeedbackListAPI } from "services/feedback";
import moment from "moment";
import useDebounce from "common/UseDebounce";
import Delete from "./Delete";

const FeedbackManag = () => {
  //*************************** Handle All State ***********************//
  const [rating, setRating] = useState(0);
  const [status, setStatus] = useState("");
  const [dateRange, setDateRange] = useState({
    startDate: "",
    endDate: "",
  });

  const [feedbackList, setFeedBackList] = useState([]);
  const [feedbackModel, setFeedbackModel] = useState(false);
  const [feedbackDetailsData, setFeedbackDetailsData] = useState();
  const [state, setState] = useState({
    delete: {
      isOpen: false,
      detail: {}
    }
  });

  const [searchValue, setSearchValue] = useState("");
  const debouncedValue = useDebounce(searchValue, 300);

  //************************** Handle All Function **********************//

  // setFeedbackDetails Handler
  const setFeedBackDetailsHandler = (item) => {
    let feedbackData = {
      feedbackText: item?.note,
      feedbackRating: item?.rating,
      userDetails: {
        occupation: "",
        image: item?.mediaUrl,
        name: item?.createdBy?.fullName,
        profileImage: item?.createdBy?.profilePicture,
      },
    };
    setFeedbackDetailsData({ ...feedbackData });

    setFeedbackModel(true);
  };

  // getFeedback List Handler
  const getFeedbackListHandler = async () => {
    try {
      const { data } = await getFeedbackListAPI({
        ...(rating && { rating }),
        ...(status && { status }),
        ...(dateRange.startDate.length && { startDate: dateRange.startDate }),
        ...(dateRange.endDate.length && { endDate: dateRange.endDate }),
        ...(searchValue && debouncedValue && { search: debouncedValue }),
      });
      console.log("I AM DATA", data);
      if (data?.success) {
        setFeedBackList(data?.data);
        console.log("I AM Feedback LIST --->>>>", data?.data);
      } else {
        toast.error(data?.message);
      }
    } catch (err) {
      console.error(err);
    }
  };

  // useEffect(() => {
  //   getFeedbackListHandler();

  //   // eslint-disable-next-line
  // }, []);

  useEffect(() => {
    getFeedbackListHandler();
  }, [debouncedValue, rating, status, dateRange]);

  //*************************** Handle HTML CODE ***********************//
  return (
    <>
      <div className="student_management">
        <div className="dashboard_title">
          <h3>FeedBack Management</h3>
        </div>
        <div className="button_section_wrap">
          <div className="search_wrapper">
            <SearchBar
              placeholder={"Search"}
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
            />

            <div className="feedback_management_header_rgt">
              <Select
                name="status"
                value={rating}
                onChange={(e) => setRating(e.target.value)}
              >
                <option value="">Rating</option>
                <option value={1}>1 Star</option>
                <option value={2}>2 Star</option>
                <option value={3}>3 Star</option>
                <option value={4}>4 Star</option>
                <option value={5}>5 Star</option>
              </Select>

              <Select
                name="status"
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <option value="">Status</option>
                <option value="ACTIVE">Active User</option>
                <option value="INACTIVE">In-Active User</option>
              </Select>

              <DatePicker
                placeholder={"Start Date"}
                selected={dateRange.startDate}
                onChange={(date) =>
                  setDateRange((prev) => ({
                    ...prev,
                    startDate: new Date(date).toISOString(),
                    endDate: prev.endDate?.length
                      ? prev.endDate
                      : new Date().toISOString(),
                  }))
                }
              />
              <DatePicker
                placeholder={"End Date"}
                selected={dateRange.endDate}
                onChange={(date) =>
                  setDateRange((prev) => ({
                    ...prev,
                    startDate: prev.startDate?.length
                      ? prev.startDate
                      : new Date().toISOString(),
                    endDate: new Date(date).toISOString(),
                  }))
                }
              />

              <CustomButton
                type="button"
                className="shorting_button"
                disabled={!dateRange?.startDate?.length}
                onClick={() => setDateRange({ startDate: "", endDate: "" })}
              >
                Reset Date Range
              </CustomButton>
            </div>
          </div>
        </div>
        <div className="card">
          <div className="card-body">
            <div className="table_wrap ">
              <table className="table custom_table">
                <thead>
                  <tr>
                    <th className="nowrap text-center">S.No</th>
                    <th className="nowrap text-center">User Name</th>
                    <th className="nowrap text-center">Submission Date</th>
                    <th className="nowrap text-center">Status</th>
                    <th className="nowrap text-center">Feedback ID</th>
                    <th className="nowrap text-center">Rating</th>
                    <th className="nowrap text-center">Action</th>
                  </tr>
                </thead>

                <tbody>
                  {feedbackList?.length > 0 &&
                    feedbackList?.map((el, ind) => (
                      <tr key={el?._id}>
                        <td className="nowrap text-center">{ind + 1}</td>
                        <td className="nowrap text-center">
                          {el?.createdBy?.fullName || "-----"}
                        </td>
                        <td className="nowrap text-center">
                          {moment(el?.createdAt).format("D/MM/YYYY") || "-----"}
                        </td>
                        <td className="nowrap text-center">{el?.status}</td>
                        <td className="nowrap text-center">
                          {el?.feedbackNumber || "-----"}
                        </td>
                        <td>
                          <div className="icon_wrap">
                            <td>
                              <div className="icon_wrap">
                                <Rating
                                  readonly
                                  size={20}
                                  iconsCount={5}
                                  fillIcon={<FaStar />}
                                  fillColor={"#ffbc0b"}
                                  emptyIcon={<FaRegStar />}
                                  initialValue={el?.rating || 0}
                                />
                              </div>
                            </td>
                          </div>
                        </td>

                        <td>
                          <div className="icon_wrap">
                            <button
                              type="button"
                              className="icon_button"
                              onClick={() => setFeedBackDetailsHandler(el)}
                            >
                              <FaEye />
                            </button>

                            <Link className="icon_button" onClick={() => setState(prev => ({ ...prev, delete: { ...prev.delete, isOpen: true, detail: el } }))}>
                              <RiDeleteBin5Line style={{ color: "red" }} />
                            </Link>
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>

            {/* <div className="pagination-wrapper">
            <div className="Pagination">
              <select className="input form-control">
                <option></option>
              </select>
            </div>
          </div> */}

            {/* <div className="pagination-wrapper">
            <div className="Pagination">
              <Pagination
                // activePage={activePage}
                previousLabel={"previous"}
                nextLabel={"next"}
                // itemsCountPerPage={limits}
                // totalItemsCount={total}
                pageRangeDisplayed={5}
                // onChange={handlePageChange}
                hideDisabled={true}
              />
            </div>
          </div> */}
          </div>
        </div>
      </div>

      {/*--------------------- Feedback Modal ----------------*/}
      <CustomModal
        show={feedbackModel}
        handleClose={() => setFeedbackModel(false)}
        className={"feedbackmanagement_model"}
      >
        <div className="feedbackmodel_heading">
          <h4>Feedback management</h4>

          <div className="feedbackmodel_wrappper">
            <div className="icon_wrapss">
              <Rating
                readonly
                size={20}
                iconsCount={5}
                fillIcon={<FaStar />}
                fillColor={"#ffbc0b"}
                emptyIcon={<FaRegStar />}
                initialValue={feedbackDetailsData?.feedbackRating}
              />
              <p>{feedbackDetailsData?.feedbackText || "-----"}</p>
            </div>

            <div className="feedbackmodel_deletebtn">
              <button className="button">
                <RiDeleteBin6Line className="delete-icon-model" /> Delete Review
              </button>
            </div>
          </div>

          <div className="ronald_wrap">
            <img
              src={
                // feedbackDetailsData?.userDetails?.profileImage ||
                feedbackDetailsData?.userDetails?.image
              }
            />
            <div className="ronald_name">
              <p>{feedbackDetailsData?.userDetails?.name || "-----"}</p>
              <div className="ronald_work">
                {/* <span>Businessman</span> */}
              </div>
            </div>
          </div>
        </div>
      </CustomModal>

      {/* Delete Modal */}
      {state.delete.isOpen && (
        <Delete
          deleteModal={state.delete.isOpen}
          selectedFaqDetail={state.delete.detail}
          setFaqList={setFeedBackList}
          closeModel={() => setState(prev => ({ ...prev, delete: { ...prev.delete, isOpen: false, detail: {} } }))}
        />
      )}
    </>
  );
};

export default FeedbackManag;
